import { uploadBase64ImageToOSS } from "@/utils/oss";
import { convertBase64UrlToBlob } from "@/utils/common";
import { getImageWidthAndHeight } from "@/utils/image";
const cuttingRulesBaseFunc = (url, suffix) => {
  if (url.indexOf('aiimg.3d66.com') >=0 || url.indexOf('imgo.3d66.com') >= 0 || url.indexOf('3d66.oss-cn-hangzhou.aliyuncs.com') >= 0 || url.indexOf('3d66-imgo.oss-cn-hangzhou.aliyuncs.com') >= 0){
    // oss域名的地址
    if (url.indexOf('!') >= 0){
      // 带了别名的裁图规则
      /*
        1、去掉别名
        2、拼接新的裁图规则
      */
      url = url.split('!')[0];
      url = url + '?x-oss-process=image' + suffix;
    } else if (url.indexOf('?x-oss-process') >= 0){
      // 带了裁图规则的地址
      url = url + suffix; 
    } else {
      // 不带裁图规则的地址
      url = url + '?x-oss-process=image' + suffix;
    }
    return url;
  } else {
    return url;
  }
};

//原!ai_index_10别名的裁图规则
const cuttingRules1 = (url) => {
  return cuttingRulesBaseFunc(url, '/resize,m_lfit,h_200/quality,Q_100/sharpen,80/format,avif');
}

//原!ai_index_7别名的裁图规则
const cuttingRules2 = (url) => {
  return cuttingRulesBaseFunc(url, '/resize,m_lfit,w_279/quality,Q_100/sharpen,80/format,avif');
}

//原!ai_index_8别名的裁图规则
const cuttingRules3 = (url) => {
  return cuttingRulesBaseFunc(url, '/resize,m_lfit,w_430/quality,Q_100/sharpen,80/format,avif');
}

const cuttingRules4 = (url) => {
  return cuttingRulesBaseFunc(url, '/format,avif/quality,Q_100/sharpen,80');
}

const cuttingRules5 = (url) => {
  return cuttingRulesBaseFunc(url, '/resize,h_350,m_lfit');
}

const cuttingRules6 = (url) => {
  return cuttingRulesBaseFunc(url, '/resize,h_209,m_lfit');
}

const cuttingRules7 = (url) => {
  return cuttingRulesBaseFunc(url, '/resize,h_160,m_lfit');
}

const cuttingRules8 = (url) => {
  return cuttingRulesBaseFunc(url, '/resize,m_lfit,h_800/quality,Q_100/sharpen,80/format,avif');
}

const cuttingRules9 = (url) => {
  return cuttingRulesBaseFunc(url, '/resize,m_lfit,w_1500/quality,Q_100/sharpen,80/format,avif');
}

// ---------------------------添加原图保护后，新的oss储存池上述规则不再可用------------------------


const clearCuttingRules = (url='') => {
  if (url.indexOf('!') >= 0) url = url.split('!')[0];
  let urlArr = url.split('?x-oss-process');
  return urlArr[0];
}
const clearCuttingRules2 = (url='') => {
  if (url.indexOf('!') >= 0) url = url.split('!')[0];
  // debugger;
  let urlArr = url.split('/auto-orient');
  return urlArr[0];
}
const clearCuttingResizeRules = (url='') => { //去除等高规则
  if (url.indexOf('!') >= 0) url = url.split('!')[0];
  // debugger;
  let urlArr = url.split('/resize');
  return urlArr[0];
}
/**
 * 将带有裁剪规则的图片 URL 转换为实际裁剪后的图片 URL
 * 通过解析 URL 中的裁剪参数（x, y, w, h），使用 canvas 绘制裁剪区域并上传裁剪后的 base64 图片至 OSS
 * @param {string} url - 带有裁剪规则的图片 URL
 * @param {(blob: Blob) => Promise<string>} [uploadFn] - 自定义上传实现（如签名URL直传 newOssV3），不传时走 /api/v1/upload/token
 * @returns {Promise<string>} 返回一个 Promise 
 */
const clearCuttingRulesByRealImg = (url='', uploadFn) => {
  return new Promise((resolve) => {
    const regex = /x_([0-9]+),y_([0-9]+),w_([0-9]+),h_([0-9]+)/;
    // 使用正则表达式提取匹配的值
    const matches = url.match(regex);
    if (matches) {
      const [, x, y, w, h] = matches;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      // 设置 canvas 尺寸为裁剪区域大小
      canvas.width = w;
      canvas.height = h;
      const img = new Image();
      img.crossOrigin = 'anonymous';
      // 原始图片地址（去除裁切参数）
      const originalUrl = clearCuttingRules(url); 
  
      img.src = originalUrl;
      img.onload = () => {
        // 在 canvas 上绘制裁剪区域
        ctx.drawImage(img, x, y, w, h, 0, 0, w, h);
        const croppedImageUrl = canvas.toDataURL('image/jpeg');
  
        const uploadTask = uploadFn
          ? uploadFn(convertBase64UrlToBlob(croppedImageUrl))
          : uploadBase64ImageToOSS(croppedImageUrl);
        uploadTask.then(imageUrl => {
          resolve(imageUrl)
          // console.log('clearCuttingRulesByRealImg', imageUrl)
        })
      };
      img.onerror = () => {
        resolve(url)
      };
    } else {
      resolve(url)
    }
  })
}
const matchingRules = (imageUrl,w,h) => {
  let maxDimension = Math.max(w, h);
  if((maxDimension > 0 && maxDimension < 1500)){
    imageUrl = `${imageUrl}!ai_draw_download_1200`
  }else if(maxDimension < 2500){
    imageUrl = `${imageUrl}!ai_draw_download_2000`
  }else if(maxDimension < 3500){
    imageUrl = `${imageUrl}!ai_draw_download_3000`
  }else if(maxDimension < 4500){
    imageUrl = `${imageUrl}!ai_draw_download_4000`
  }else{
    imageUrl = `${imageUrl}!ai_draw_download_5000`
  }
  return imageUrl
}
/**
 * 给图片加上水印裁图规则
 * @param {string} url - 图片 URL
 * @returns {Promise<string>} 返回一个 Promise 
 */
const addCuttingRulesByWatermark = (imageUrl, w = null, h = null) => {
  return new Promise((resolve) => {
    imageUrl = clearCuttingRules(imageUrl);
    if(imageUrl.indexOf('!ai_draw_download') === -1){
      // 用户下载时，给图片加上水印
      if(w && h){
        resolve(matchingRules(imageUrl,w,h))
      }
      getImageWidthAndHeight(imageUrl, (w, h) => {
        resolve(matchingRules(imageUrl,w,h))
      })
    }else{
      resolve(imageUrl)
    }
  });
}

export {
  cuttingRules1,
  cuttingRules2,
  cuttingRules3,
  cuttingRules4,
  cuttingRules5,
  cuttingRules6,
  cuttingRules7,
  cuttingRules8,
  cuttingRules9,
  clearCuttingRules,
  clearCuttingRules2,
  clearCuttingResizeRules,
  clearCuttingRulesByRealImg,
  addCuttingRulesByWatermark,
};